import { z } from 'zod';

export const PartyGenderSchema = z.enum(['MALE', 'FEMALE', 'OTHERS']);
export type PartyGender = z.infer<typeof PartyGenderSchema>;

export const PartyFamilyRoleSchema = z.enum([
  'FATHER',
  'MOTHER',
  'GRANDPA',
  'GRANDMA',
  'SPOUSE',
  'CHILD',
  'GUARDIAN',
  'DEPENDENT',
  'OTHER',
]);
export type PartyFamilyRole = z.infer<typeof PartyFamilyRoleSchema>;

export const PartyPfProfileFieldsSchema = z.object({
  rg: z.string().trim().nullable().optional(),
  nickname: z.string().trim().nullable().optional(),
  occupation: z.string().trim().nullable().optional(),
  jobTitle: z.string().trim().nullable().optional(),
  driversLicenseExpiry: z.iso.date().nullable().optional(),
  photoUrl: z.url().nullable().optional(),
  familyRole: PartyFamilyRoleSchema.nullable().optional(),
});
